import React from 'react'
import { Col, List, Row, Typography } from 'antd'
import CustomList from '../../../components/Shared/CustomList'
import CustomVideo from '../../../components/Shared/CustomVideo'
import { GeneralTitle } from '../../../components/Shared'

const { Title, Paragraph } = Typography

const services = [
	'WordPress Custom Development',
	'WordPress Database',
	'WordPress API',
	'WordPress Assistant Services'
]

const Wordpress = () => {
	return (
		<>
			<GeneralTitle>WordPress</GeneralTitle>

			<Row gutter={[20, 20]} justify="space-between" align="middle">
				<Col xs={24} sm={24} md={14} lg={14}>
					<Title level={4}>
						We do more than just basic WordPress web design
					</Title>
					<Paragraph>
						Webackit.com offers custom-made{' '}
						<b>Premium WordPress Solutions</b>, built specifically
						for your needs with the user in mind. We created our
						WordPress theme and plugins, limiting the security
						vulnerabilities and the code usage.
					</Paragraph>
					<Paragraph>
						It is not enough to have a website in today's
						increasingly competitive online marketplace.
					</Paragraph>
					<Paragraph>
						You need an intelligently designed website that makes it
						easy for your customers to find what they need and make
						a purchase or schedule an appointment online. It would
						help if you had a WordPress agency in your corner,
						dedicated to you and the success of your business.
					</Paragraph>
					<CustomList
						dataSource={services}
						renderItem={(item) => <List.Item>{item}</List.Item>}
					/>
				</Col>
				<Col xs={24} sm={24} md={10} lg={10}>
					<img
						width="100%"
						src={`${process.env.PUBLIC_URL}/branding/webackit-services-diagram-wordpress.svg`}
						alt="WordPress Services Diagram"
					/>
				</Col>
			</Row>

			<CustomVideo
				src="https://webackit.com/videos/webackit-custom-wordpress-services.mp4"
				type="video/mp4"
				styleProps={{
					width: '100%'
				}}
			/>
		</>
	)
}

export default Wordpress
